import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";
import { applyToolResult } from "./provideToolResultShared";

export const providePersonalChatToolResultSchema = z.object({
  chatId: z.string(),
  entryId: z.string(),
  output: z.any(),
  isError: z.boolean().optional(),
  pauseAfter: z.boolean().optional(),
  chatModel: z.string().optional(),
});

export const providePersonalChatToolResult = mutator({
  schema: providePersonalChatToolResultSchema,
  resolve: {},
  permissions: {
    none: "the chat is resolved through the caller’s own personalChats row, and the tool-call entry is scoped to that chat",
  },
  fn: async ({ tx, ctx, args }) => {
    const { chatId, pauseAfter } = args;
    const [pc] = await tx.run(
      zql.personalChats.where("chatId", chatId).where("userId", ctx.userId)
    );
    if (!pc) throw userFacingError("Personal chat not found");

    await applyToolResult(tx, args);

    const respondingAt = pauseAfter ? null : Date.now();
    await tx.mutate.chats.update({
      id: chatId,
      respondingAt,
      awaitingAction: false,
    });
  },
});
